<template>
  <el-container>
    <el-aside width="280px" :class="{ collapse: collapse }">
      <SideMenu />
    </el-aside>
    <el-container class="app-wrapper">
      <el-header>
        <Header />
      </el-header>
      <el-main>
        <el-scrollbar ref="scrollbar" class="custom app">
          <keep-alive :exclude="exclude">
            <router-view :key="path" class="container" />
          </keep-alive>
          <el-backtop target=".el-scrollbar .el-scrollbar__wrap" :visibility-height="100" :bottom="60" />
        </el-scrollbar>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from "./header";
import SideMenu from "./side-menu";
export default {
  name: "Layout",
  components: { Header, SideMenu },
  data() {
    return {
      scrollTopCache: [],
    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
    collapse() {
      return this.$store.state.sideMenuCollapse;
    },
    token() {
      return this.$store.state.token;
    },
    exclude() {
      return this.$store.state.exclude;
    },
    routeName() {
      return this.$route.name;
    },
    cacheIndex() {
      return this.scrollTopCache.findIndex((i) => i.path === this.path);
    },
  },
  watch: {
    $route: "show",
  },
  mounted() {
    this.handleScroll();
  },
  methods: {
    show() {
      if (this.token) {
        this.$nextTick(() => {
          this.activeScrollTop();
        });
      }
    },
    handleScroll() {
      let wrap = this.$refs.scrollbar.wrap;
      if (wrap) {
        wrap.onscroll = () => {
          this.updateScrollTopCache(wrap.scrollTop);
        };
      }
    },
    activeScrollTop() {
      let wrap = this.$refs.scrollbar.wrap;
      let index = this.cacheIndex;
      if (index !== -1 && wrap) {
        wrap.scrollTop = this.scrollTopCache[index].scrollTop;
      }
    },
    updateScrollTopCache(scrollTop) {
      let index = this.cacheIndex;
      if (index !== -1) {
        this.$set(this.scrollTopCache[index], "scrollTop", scrollTop);
      } else {
        this.scrollTopCache.push({
          path: this.path,
          scrollTop: scrollTop,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-container,
.el-main {
  height: 100%;
  width: 100%;
}

.el-container {
  overflow: hidden;

  &.app-wrapper {
    flex-direction: column !important;
  }
}

.el-aside {
  width: $side-menu-width;
  transition: width 0.18s;

  &.collapse {
    width: 64px !important;
  }
}

.el-header {
  padding: 0 !important;
  height: auto !important;
  background: none;
}

.el-main {
  min-height: auto;
  padding: 0 !important;

  .container {
    min-height: calc(100vh - 50px);
    padding: 0px 15px 15px;
    background-color: #f2f3f6;

    &.no-padding {
      padding: 0px;
      min-height: calc(100vh);
    }

    ::v-deep {
      &>.page-header-wrapper {
        padding: 10px 10px 0px;
        margin-bottom: 15px;
        border-radius: 10px;
        background-color: #fff;

        .filter-wrapper {
          padding: 10px 0;
        }

        .el-form-item {
          margin-bottom: 0;
        }

        &.padding-rb {
          padding-right: 10px;
          padding-bottom: 5px;
        }
      }

      &>.table-wrapper {
        overflow: hidden;
        border-radius: 10px;
        background-color: #fff;
        padding: 15px;

        .el-table {
          min-height: 100px;

          &:not(.el-table--scrollable-x):before {
            content: none;
          }
        }
      }
      
      &>.info-wrapper {
        overflow: hidden;
        border-radius: 10px;
        background-color: #fff;
        padding: 15px;
        margin-bottom: 15px;
      }
    }
  }
}

.el-backtop {
  color: #d52b1e;
}
</style>
